module.exports = __webpack_public_path__ + "static/6305-woodrose-3-8bb70cd69dae655095dab2409428ee24.jpg";